import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';

import {Paper} from '@mui/material';
import {Typography} from '@mui/material';

const styles = (theme:Theme):StyleRules => ({
  // theme.mixins.gutters has been deprecated
  // root: theme.mixins.gutters({
  //   paddingTop: 16,
  //   paddingBottom: 16,
  //   marginTop: theme.spacing(2), //.unit * 3,
  //   marginBottom: theme.spacing(2), //.unit * 3,
  //   border: "1px solid #ccc"
  // }),
  root:{   
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing(2), //.unit * 3,
    marginBottom: theme.spacing(2), //.unit * 3,
    border: "1px solid #ccc",
    paddingLeft: 16,
    paddingRight: 16
  },
  appBarButton:{}
})

interface Props extends React.HTMLProps<HTMLDivElement>{
  text: string
  headlineText?: string
  elevation?: number
}

type State = {
};

class EmptySet extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props:Props & WithStyles<keyof typeof styles>) {
    super(props)
    this.state = {}; 
  }

  render () {


    const { classes }: { classes:ClassNameMap } = this.props
    const { text, headlineText } = this.props

    return (
        <Paper className={classes.root} elevation={this.props.elevation || 0}>
          <Typography variant="h5">
            {headlineText || ""}
          </Typography>
          <Typography component="p">
            {text}
          </Typography>
        </Paper>
    );
  }
}

export default withStyles(styles)(EmptySet);
